export const format_time = (second: number): string => {
  const h: number = Math.floor( second / 60 / 60 );
  const m: number = Math.floor( second / 60 % 60 );
  const s: number = Math.floor( second % 60 );

  return (h > 0 ? String(h) + ':' : '') + ("00" + String(m)).slice(-2) + ':' + ("00" + String(s)).slice(-2);
}
